import { motion } from "framer-motion";

function scrollToSection(id) {

  const el =
    document.getElementById(id);

  if (el) {

    el.scrollIntoView({
      behavior: "smooth",
    });

  }
}

export default function Navbar() {

  return (

    <motion.nav

      initial={{
        y: -50,
        opacity: 0,
      }}

      animate={{
        y: 0,
        opacity: 1,
      }}

      transition={{
        duration: 0.8,
      }}

      className="fixed top-0 left-0 w-full z-50 backdrop-blur-xl bg-black/30 border-b border-zinc-900"
    >

      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">

        {/* LOGO */}
        <button
          onClick={() =>
            window.location.hash = "/"
          }
          className="text-2xl font-bold text-white"
        >
          <span className="text-blue-500">
            d3ad
          </span>
          0x1
        </button>

        {/* NAV */}
        <div className="flex items-center gap-8 text-zinc-400">

          <button
            onClick={() =>
              scrollToSection(
                "timeline"
              )
            }
            className="hover:text-white transition"
          >
            Timeline
          </button>

          <button
            onClick={() =>
              scrollToSection(
                "writeups"
              )
            }
            className="hover:text-white transition"
          >
            Write-ups
          </button>

          <button
            onClick={() =>
              scrollToSection(
                "contact"
              )
            }
            className="hover:text-white transition"
          >
            Contact
          </button>

        </div>

      </div>

    </motion.nav>

  );
}